// extracted by mini-css-extract-plugin
export default {"searchContent":"Search_searchContent__QfiIm"};